import { render, staticRenderFns } from "./CreateLesson.vue?vue&type=template&id=2d6bbda2&scoped=true&"
import script from "./CreateLesson.vue?vue&type=script&lang=js&"
export * from "./CreateLesson.vue?vue&type=script&lang=js&"
import style0 from "./CreateLesson.vue?vue&type=style&index=0&id=2d6bbda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bbda2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VTab,VTabItem,VTabs})
